import { useWallet } from "../wallet/WalletContext";
import { ACTIVE_CHAIN } from "../config/chains";
import { formatEth, truncateAddress } from "../lib/format";
import { Button, Pill } from "./ui";

export function WalletButton() {
  const {
    address,
    isConnected,
    chainId,
    balance,
    hasInjected,
    connecting,
    connect,
    disconnect,
    switchToTestnet,
  } = useWallet();

  const wrongNetwork = isConnected && chainId !== ACTIVE_CHAIN.chainId;

  if (!hasInjected) {
    return (
      <Pill tone="warn">
        <span className="hidden sm:inline">No injected wallet detected</span>
        <span className="sm:hidden">No wallet</span>
      </Pill>
    );
  }

  if (!isConnected) {
    return (
      <Button onClick={() => void connect()} disabled={connecting}>
        {connecting ? "Check your wallet…" : "Connect wallet"}
      </Button>
    );
  }

  return (
    <div className="flex items-center gap-2">
      {wrongNetwork ? (
        <Button variant="danger" onClick={() => void switchToTestnet()}>
          Switch to Testnet
        </Button>
      ) : (
        /* Connected state: network badge + address chip */
        <div className="flex items-center gap-2">
          {/* Network badge — hidden on smallest screens */}
          <Pill tone="plasma">
            <span className="hidden sm:inline">{ACTIVE_CHAIN.label}</span>
            <span className="sm:hidden">Testnet</span>
          </Pill>

          {/* Address + balance chip */}
          <div
            className="hidden sm:flex flex-col items-end leading-tight rounded-lg px-2.5 py-1.5 border border-line/80 bg-panel/60"
            style={{ borderColor: "rgba(0,229,199,0.12)" }}
          >
            <span className="font-mono text-xs text-ink tracking-tight">
              {address ? truncateAddress(address) : ""}
            </span>
            <span className="text-[10px] text-muted font-mono">
              {balance !== null ? formatEth(balance) : "—"}
            </span>
          </div>
        </div>
      )}
      <Button variant="ghost" onClick={disconnect} className="text-xs px-3 py-1.5">
        Disconnect
      </Button>
    </div>
  );
}
